// extracted by mini-css-extract-plugin
export default {"error-boundary":"error-boundary_RY5ejRyj5M"};